import Transform from "@ember-data/serializer/transform";

export default class ChildrenTransform extends Transform {
  override deserialize(serialized) {
    serialized?.forEach(child => {
      // Make sure birthyear are of type Date and not string.
      // This is useful when passing the birthyear in a DatePicker, which must have a Date and not a string.
      if (child.birthyear) {
        child.birthyear = new Date(child.birthyear);
      }
    });
    return serialized;
  }

  override serialize(deserialized) {
    return deserialized;
  }
}

declare module "ember-data/types/registries/transform" {
  export default interface TransformRegistry {
    children: ChildrenTransform;
  }
}
